<div class="container-fluid p-0">
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <button mat-raised-button routerLink="/sites" class="m-1 mr-2">
      <mat-icon>arrow_back</mat-icon> {{ utils.getLangTerm('sites.plural', 'Sites') }}
    </button>

    <button mat-raised-button *ngIf="child_id" [routerLink]="'/sites/'+parent_id+'/children'" class="m-1 mr-2">
      <mat-icon>arrow_back</mat-icon> {{ utils.getLangTerm('child-sites.plural', 'Subsites') }}
    </button>
  </nav>

  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <span class="navbar-brand">{{ utils.getLangTerm('hazardous-substances.list.site-title', 'Hazardous Substances')
      }}</span>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <span class="mr-auto">

        <button *ngIf="canCreate" mat-raised-button color="primary" class="m-1 mr-2" (click)="onEdit('new')">
          <mat-icon>add</mat-icon>
          New
        </button>

        <ng-container *ngIf="canEdit || canView">
          <mat-menu #appMenu="matMenu">
            <button mat-menu-item (click)="dataSource.selectAllToggle()">
              <mat-icon *ngIf="dataSource.isAllSelected()"> clear_all</mat-icon><mat-icon
                *ngIf="!dataSource.isAllSelected()">select_all</mat-icon>
              {{ dataSource.isAllSelected() ? 'Deselect' : 'Select' }} All
            </button>

            <button mat-menu-item (click)="onExportSelected('pdf')">
              <mat-icon>cloud_download</mat-icon> Export {{ dataSource.selection.hasValue() ? 'Selected' : 'All' }} to PDF
            </button>

            <button mat-menu-item (click)="onExportSelected('csv')">
              <mat-icon>cloud_download</mat-icon> Export {{ dataSource.selection.hasValue() ? 'Selected' : 'All' }} to CSV
            </button>

            <ng-container *ngIf="canEdit">
              <button mat-menu-item (click)="onSelectHazardousSubstance()">
                <mat-icon>link_on</mat-icon> Link
              </button>
              
              <button mat-menu-item (click)="onLinkAllHazardousSubstances()">
                <mat-icon>link_on</mat-icon> Link All
              </button>

              <button mat-menu-item (click)="onUnlinkSelectedHazardousSubstances()"
                [disabled]="!dataSource.selection.hasValue()">
                <mat-icon>link_off</mat-icon> Unlink Selected
              </button>

              <button mat-menu-item (click)="onUnlinkAllHazardousSubstances()">
                <mat-icon>link_off</mat-icon> Unlink All
              </button>
            </ng-container>
          </mat-menu>

          <button mat-button class="m-1 mr-2" [matMenuTriggerFor]="appMenu"
            matTooltip="Use this menu to select/deselect and/or export records." style="min-width: 150px">
            <mat-icon>more_vert</mat-icon>
            List Menu/Export
          </button>
        </ng-container>
      </span>

      <ng-container *ngIf="canView">
        <button mat-raised-button class="m-1 mr-lg-3" (click)="onFilter()"
          matTooltip="Click this button to display filter options.">
          <mat-icon>filter_list</mat-icon> Filter
        </button>

        <form class="form-inline mx-1 my-0" (ngSubmit)="dataSource.getData(true)">
          <input class="form-control ml-0 mr-2 my-1" type="search" [(ngModel)]="dataSource.search" name="search"
            placeholder="Search" aria-label="Search" />

          <button mat-raised-button color="secondary" type="submit" class="mx-0 my-1">
            <mat-icon>search</mat-icon> Search
          </button>
        </form>
      </ng-container>
    </div>
  </nav>

  <div class="alert alert-warning m-2" *ngIf="!canView">
    <mat-icon class="align-middle mr-2">info</mat-icon>
    You do not have permission to view site hazardous substances.
    <span *ngIf="canCreate">You can still create new hazardous substances using the button above.</span>
    <span *ngIf="!canCreate">Please contact your administrator to request access.</span>
  </div>

  <div class="mat-elevation-z8 scroll-box" *ngIf="canView">
    <table mat-table [dataSource]="dataSource" matSort matSortActive="substance" matSortDirection="asc"
      matSortDisableClear>
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef [style.width.px]="65">
          <mat-checkbox (change)="$event ? dataSource.selectAllToggle() : null"
            [checked]="dataSource.selection.hasValue() && dataSource.isAllSelected()"
            [indeterminate]="dataSource.selection.hasValue() && !dataSource.isAllSelected()">
          </mat-checkbox>
        </th>

        <td mat-cell *matCellDef="let row">
          <mat-checkbox (click)="$event.stopPropagation()"
            (change)="$event ? dataSource.selection.toggle(row.id) : null"
            [checked]="dataSource.selection.isSelected(row.id)">
          </mat-checkbox>
        </td>
      </ng-container>

      <!-- ID Column -->
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          #
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.id }}
        </td>
      </ng-container>

      <!-- Hazardous Substance -->
      <ng-container matColumnDef="substance">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ utils.getLangTerm('hazardous-substances.singular', 'Hazardous Substance') }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.substance }}
        </td>
      </ng-container>

      <!-- Hazardous Substance Type -->
      <ng-container matColumnDef="hazardous_substance_type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by type">
          Type
        </th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element?.hazardous_substance_type">
            {{ ('(' + element?.hazardous_substance_type?.substring(0, 1) + ') ') + element.hazardous_substance_type }}
          </ng-container>
        </td>
      </ng-container>

      <!-- Hazardous Substance Unit Type -->
      <ng-container matColumnDef="hazardous_substance_unit_type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by unit type">
          Unit Type
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.hazardous_substance_unit_type }}
        </td>
      </ng-container>

      <!-- Hazardous Substance Quantity -->
      <ng-container matColumnDef="quantity">
        <th mat-header-cell *matHeaderCellDef matTooltip="The quantity that is currently held onsite.">
          Quantity
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element?.pivot?.quantity || '' }}
        </td>
      </ng-container>

      <!-- Hazardous Substance Max Allowed Quantity -->
      <ng-container matColumnDef="max_quantity_allowed">
        <th mat-header-cell *matHeaderCellDef matTooltip="The max quantity that is allowed to be held onsite.">
          Max Quantity Allowed
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element?.pivot?.max_quantity_allowed || '' }}
        </td>
      </ng-container>

      <!-- Hazardous Substance Location -->
      <ng-container matColumnDef="location">
        <th mat-header-cell *matHeaderCellDef matTooltip="The location where it is stored.">
          Location
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element?.pivot?.location || '' }}
        </td>
      </ng-container>

      <!-- Expiry Date of Safety Data Sheet (SDS) -->
      <ng-container matColumnDef="sds_expires_at">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          SDS Expires At
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.sds_expires_at ? ((element.sds_expires_at * 1000) | timezoneConvertMedium) : '' }}
        </td>
      </ng-container>

      <!-- Date Created Column -->
      <ng-container matColumnDef="date_created">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Date Created
        </th>
        <td mat-cell *matCellDef="let element">
          {{ (element.date_created * 1000) | timezoneConvertMedium }}
        </td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef [style.width.px]="240"></th>

        <td mat-cell *matCellDef="let element">
          <button type="button" mat-button (click)="onEditInventory(element)" *ngIf="canEdit">
            Edit
          </button>

          <button type="button" mat-button (click)="onUnlinkHazardousSubstance(element.id)" *ngIf="canEdit">
            Unlink
          </button>

          <button type="button" mat-button (click)="onCreateFrom(element)" *ngIf="canCreate">
            Clone
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator [length]="dataSource?.total | async" [pageSize]="dataSource.limit"
      [pageSizeOptions]="dataSource.pageSizeOptions" showFirstLastButtons>
    </mat-paginator>
  </div>
</div>
